import React from "react";
import { View, Text } from "../../Components";
import { Metrics, Helpers, Colors, sensorLive, Spacing } from "../../global";
import { Color } from "@rc-component/color-picker";

const TableView = ({ currentStore, allSites }) => {
  let totalAlertCount = 0;
  let alarmStatusBackgroundColor = Colors.successLight;
  let alarmStatusTextColor = "greenDark";
  currentStore?.tools?.forEach((mac) => {
    let alerts = currentStore?.[mac]?.alerts;
    let hasAlert = alerts != null && Array.isArray(alerts) && alerts.length > 0;
    let alertLength = 0;
    if (hasAlert) {
      alertLength = 0;
      alerts.forEach((alert) => {
        alertLength += alert.alertState.alertCnt;
      });
      totalAlertCount += alertLength;
    }
  });

  let totalOfflineCount = 0;
  let connectionStatusBackgroundColor = Colors.successLight;
  let connectionStatusTextColor = "greenDark";
  currentStore?.tools?.forEach((mac) => {
    if (sensorLive.isLive(currentStore?.[mac]?.sensor?.updatedAt) === false) {
      totalOfflineCount++;
    }
  });

  if (totalOfflineCount > 0) {
    connectionStatusBackgroundColor = Colors.errorLight;
    connectionStatusTextColor = "redDark";
  }

  if (totalAlertCount > 0) {
    alarmStatusBackgroundColor = Colors.errorLight;
    alarmStatusTextColor = "redDark";
  }

  return (
    <table
      style={{
        justifyContent: "space-evenly",
        alignItems: "center",
        height: "20%",
        width: "310px",
        border: "1px solid",
        borderColor: Colors.darkLightGrey,
        borderWidth: 1,
        padding: 0,
        borderCollapse: "collapse",
        borderRadius: "10px",
      }}
    >
      <thead style={{ backgroundColor: Colors.darkLightGrey, borderRadius: 8 }}>
        <tr>
          <th
            colSpan="2"
            style={{
              borderBottom: "1px solid",
              borderColor: Colors.darkLightGrey,
              textAlign: "left",
              padding: 8,
            }}
          >
            Summary
          </th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td
            style={{
              border: "1px solid ",
              borderRight: "1px solid",
              borderColor: Colors.darkLightGrey,
              textAlign: "center",
            }}
          >
            Connection Status
          </td>

          <td
            style={{
              border: "1px solid ",
              borderColor: Colors.darkLightGrey,
              borderBottom: `1px solid ${Colors.darkLightGrey}`,
              backgroundColor: connectionStatusBackgroundColor,
              textAlign: "right",
              padding: 8,
            }}
          >
            {totalOfflineCount > 0
              ? totalOfflineCount + " Offline"
              : "All Online"}
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: "1px solid ",
              borderRight: "1px solid",
              borderColor: Colors.darkLightGrey,
              textAlign: "center",
            }}
          >
            Alarm Status
          </td>
          <td
            style={{
              border: "1px solid ",
              borderColor: Colors.darkLightGrey,
              borderBottom: `1px solid ${Colors.darkLightGrey}`,
              backgroundColor: alarmStatusBackgroundColor,
              textAlign: "right",
              padding: 8,
            }}
          >
            {totalAlertCount > 0 ? totalAlertCount + " Alarms" : "No Alarms"}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default TableView;
